import { ApolloError } from "@apollo/client";

interface UserTokensType {
  balance: string;
  decimals: number;
  identifier: string;
  name: string;
  type: string;
  valueUSD: string;
}

interface UserNftTokensType {
  identifier: string;
  collection: string;
  name?: string;
  balance: string;
  valueUSD: string;
  decodedAttributes?: any;
}

export interface LeaderboardEntryType {
  address: string;
  netWorth: number;
  nonce: number;
  balance: string;
  teamMember?: boolean;
  balanceUSD: string;
  userTokens: UserTokensType[];
  userNftTokens: UserNftTokensType[];
}

export interface StateType {
  leaders: {
    loading?: boolean;
    data?: { timestamp: string; leaderboard: LeaderboardEntryType[] };
    error?: string | ApolloError;
  };
}

const initialState = (): StateType => {
  return {
    leaders: {
      data: undefined,
      loading: undefined,
      error: undefined,
    },
  };
};

export default initialState;
